import {
  ActionIcon,
  Button,
  Checkbox,
  Popover,
  Stack,
  Text,
} from "@mantine/core";
import { IconDots, IconExternalLink } from "@tabler/icons-react";
import { useMemo, useState } from "react";
import { useReportingStore } from "../../../stores/ReportingStore";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../stores/LanguageStore";

const LinkGrabber = () => {
  const lang = useLanguage((s) => s.language);
  const [selected, setSelected] = useState([]);

  const items = useMemo(
    () => [
      { label: lang.statistics.contacts_type.postitive, value: "positive" },
      { label: lang.statistics.contacts_type.negative, value: "negative" },
      { label: lang.reports.others, value: "neutral" },
    ],
    []
  );

  const handleSelect = (value) => {
    setSelected((prev) => {
      if (prev.includes(value)) {
        return [...prev].filter((x) => x !== value);
      } else {
        return [...prev, value];
      }
    });
  };

  const handleSelectAll = () => {
    if (selected.length === items.length) {
      setSelected([]);
    } else {
      setSelected(items.map((x) => x.value));
    }
  };

  const navigate = useNavigate();
  const handleSubmit = () => {
    let filter = {
      mode: "or",
      values: [],
    };

    if (selected.includes("positive")) {
      filter.values.push({
        field_name: "is_positive",
        type: "equals",
        value: "1",
      });
    }
    if (selected.includes("negative")) {
      filter.values.push({
        field_name: "is_positive",
        type: "equals",
        value: "0",
      });
    }
    if (selected.includes("neutral")) {
      filter.values.push({
        field_name: "is_positive",
        type: "equals",
        value: "null",
      });
    }

    const programmations = useReportingStore.getState().programmations;
    const dateRange = useReportingStore.getState().dateRange;
    const integrations = useReportingStore.getState().integrations;

    programmations.forEach((prog) => {
      filter.values.push({
        field_name: "programmation_id",
        type: "equals",
        value: prog.id.toString(),
      });
    });

    integrations.forEach((account) => {
      filter.values.push({
        field_name: "integration_id",
        type: "equals",
        value: account.id.toString(),
      });
    });

    if (dateRange.start_date && dateRange.end_date) {
      filter.values.push({
        mode: "and",
        values: [
          {
            field_name: "created_on",
            type: "more_than",
            value: new Date(dateRange.start_date).toISOString(),
          },
          {
            field_name: "created_on",
            type: "less_than",
            value: new Date(dateRange.end_date).toISOString(),
          },
        ],
      });
    }

    return navigate(`/leads-tracking?filter=${JSON.stringify(filter)}`);
  };

  return (
    <Popover>
      <Popover.Target>
        <ActionIcon
          variant="subtle"
          size={"xl"}
          pos={"absolute"}
          top={8}
          right={8}
        >
          <IconDots size={32} />
        </ActionIcon>
      </Popover.Target>

      <Popover.Dropdown>
        <Stack>
          <Text>{lang.reports.view_prm}</Text>

          <Checkbox
            label={"Tous"}
            checked={selected.length === items.length}
            onClick={handleSelectAll}
            indeterminate={
              selected.length > 0 && selected.length < items.length
            }
          />

          {items.map((item) => (
            <Checkbox
              key={item.value}
              label={item.label}
              onClick={() => handleSelect(item.value)}
              checked={selected.includes(item.value)}
            />
          ))}

          <Button
            onClick={handleSubmit}
            rightSection={<IconExternalLink size={18} />}
            disabled={selected.length === 0}
          >
            {lang.reports.view_leads}
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default LinkGrabber;
